import bridge from '@bridge/imlv';
import semver from 'semver';
import { parse } from 'query-string';
import { isExistUser } from '@services/jsb';

const u = navigator.userAgent;
export const isIos = Boolean(u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/));

export function formatCount(count: number): number | string {
  if (count < 1000) {
    return count;
  }
  if (count > 1000 && count < 1000 * 1000) {
    return `${Math.floor(count / 100) / 10}K`;
  }
  return `${Math.floor(count / 100000) / 10}M`;
}

export function formatMoney(value: number, isFixed = true) {
  let yuan = isFixed ? value || 0 : parseInt(String((value || 0) / 100), 10);
  yuan = yuan / 100;
  return yuan.toFixed(isFixed ? 2 : 0).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export const isWindow = (obj: object) => {
  const toString = Object.prototype.toString.call(obj);
  return toString === '[object global]' || toString === '[object Window]' || toString === '[object DOMWindow]';
};

export const scrollTop = (ele: Element | Window, target?: number) => {
  const isWin = isWindow(ele);
  const y =
    window.pageYOffset !== undefined ?
      window.pageYOffset :
      (document.documentElement || document.body.parentNode || document.body).scrollTop;

  if (target && !isNaN(target)) {
    if (isWin) {
      document.documentElement.scrollTop = target;
      document.body.scrollTop = target;
    } else {
      (ele as Element).scrollTop = target;
    }
  }

  return isWin ? y : (ele as Element).scrollTop;
};

export function scrollGate(down: Function, up: Function): () => void {
  let before = 0;

  return function () {
    const current = scrollTop(window);
    const delta = current - before;

    if (delta >= 0) {
      down && down();
    } else {
      up && up();
    }

    before = current;
  };
}

export function safeSet(obj: any, path: string, value: any) {
  if (Object(obj) !== obj) {
    return obj;
  }
  let paths: string[] = [];
  if (!Array.isArray(path)) {
    paths = path.toString().match(/[^.[\]]+/g) || [];
  }
  paths.slice(0, -1).reduce(
    (
      acc,
      cur,
      index // Iterate all of them except the last one
    ) =>
      (Object(acc[cur]) === acc[cur] ?
        acc[cur] : // No: create the key. Is the next key a potential array-index?
        (acc[cur] =
            Math.abs(Number(paths[index + 1])) >> 0 === Number(paths[index + 1]) ?
              [] : // Yes: assign a new array object
              {})), // No: assign a new plain object
    obj
  )[paths[paths.length - 1]] = value; // Finally assign the value to the last key
  return obj; // Return the top-level object to allow chaining
}

export function noop() {
  // noop 空函数
}

export function wakeUpApp(href: string) {
  window.location.href = href;
  setTimeout(() => {
    window.location.href = 'https://www.capcut.net/app?language=en';
  }, 2000);
}

// > minVersion 返回true
export async function supportVersion(judgeStr: string) {
  const { userAgent } = navigator;
  try {
    if (/LV/.test(userAgent)) {
      // 获取app版本号
      const { data } = await bridge.app.getAppInfo();
      return semver.satisfies(data.appVersion, judgeStr);
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}

export function base64ToBlob(base64: string) {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1]; // 分割 mime 和 图片数据
  const bstr = atob(arr[1]); // 去掉 url 头，并转化为 byte
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

const channelAttrKey = 'header'; // 泳道属性key
const envAttrKey = 'env'; // 环境属性key,取值为boe/ppe

export function getUrlWithEnv(path: string) {
  const url = new URL(path);
  const query = parse(location.search);
  if (query[channelAttrKey] && !url.searchParams.has(channelAttrKey)) {
    url.searchParams.set(channelAttrKey, query[channelAttrKey] as string);
  }
  if (query[envAttrKey] && !url.searchParams.has(envAttrKey)) {
    url.searchParams.set(envAttrKey, query[envAttrKey] as string);
  }
  return url.href;
}

export function versionCompare(left, right) {
  if (typeof left + typeof right !== 'stringstring') {
    return false;
  }
  const a = left.split('.');
  const b = right.split('.');
  const len = Math.max(a.length, b.length);
  let i = 0;

  for (; i < len; i++) {
    if ((a[i] && !b[i] && parseInt(a[i]) > 0) || parseInt(a[i]) > parseInt(b[i])) {
      return 1;
    } else if ((b[i] && !a[i] && parseInt(b[i]) > 0) || parseInt(a[i]) < parseInt(b[i])) {
      return -1;
    }
  }

  return 0;
}
